function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RwandaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1599",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1599)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#FECA00"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1599",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1599)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V13.5H24V3H0Z",
        fill: "#3CA5D9"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 16.5V21H24V16.5H0Z",
        fill: "#5A962A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.0614 11.8992C18.0365 11.8998 18.0115 11.9001 17.9865 11.9001C17.9651 11.9001 17.9437 11.8999 17.9224 11.8994L17.4691 13.3798L17.3732 11.8378C17.3273 11.8284 17.2817 11.8179 17.2366 11.8063L16.4516 13.1413L16.7174 11.6212C16.6746 11.6014 16.6323 11.5805 16.5907 11.5587L15.5171 12.6771L16.1293 11.2605C16.092 11.2312 16.0555 11.201 16.0196 11.17L14.716 12.0122L15.6404 10.7756C15.6105 10.7383 15.5816 10.7002 15.5536 10.6614L14.0916 11.1825L15.2769 10.1921C15.2563 10.1485 15.2368 10.1043 15.2184 10.0595L13.6774 10.2327L15.0598 9.54033C15.0501 9.49292 15.0415 9.44509 15.0341 9.39687L13.4958 9.21401L15.0015 8.85589C15.0031 8.80691 15.0058 8.75822 15.0098 8.70986L13.5566 8.18138L15.1038 8.1764C15.1168 8.12896 15.131 8.08199 15.1463 8.03552L13.8565 7.19045L15.3634 7.5386C15.3871 7.49561 15.412 7.45327 15.4378 7.41161L14.3794 6.29465L15.7656 6.97772C15.7985 6.94155 15.8324 6.90618 15.8671 6.87165L15.097 5.54227L16.2873 6.52373C16.3276 6.49615 16.3686 6.46951 16.4103 6.44387L15.9706 4.97386L16.9006 6.20109C16.946 6.18357 16.992 6.16711 17.0384 6.15176L16.9533 4.62008L17.5728 6.02808C17.6206 6.02153 17.6688 6.01611 17.7173 6.01182L17.9919 4.5L18.2667 6.01281C18.315 6.01725 18.3629 6.02282 18.4105 6.02949L19.0306 4.62008L18.9452 6.15529C18.9909 6.17058 19.0362 6.18694 19.0808 6.20433L20.0132 4.97386L19.5719 6.4495C19.6125 6.47467 19.6524 6.50077 19.6917 6.52778L20.8869 5.54227L20.1128 6.87848C20.1463 6.91201 20.179 6.94633 20.2108 6.9814L21.6045 6.29465L20.5395 7.41851C20.5643 7.45866 20.5881 7.49944 20.6109 7.54082L22.1274 7.19045L20.8287 8.04135C20.8433 8.0859 20.8568 8.13092 20.8693 8.17637L22.4273 8.18138L20.9636 8.71368C20.9673 8.75993 20.9699 8.80648 20.9715 8.8533L22.4881 9.21401L20.9388 9.39818C20.9317 9.44429 20.9235 9.49005 20.9143 9.53542L22.3065 10.2327L20.7551 10.0584C20.7375 10.1013 20.7189 10.1437 20.6993 10.1857L21.8923 11.1825L20.4217 10.6583C20.3947 10.6958 20.3669 10.7325 20.3383 10.7686L21.2679 12.0122L19.958 11.166C19.9233 11.1962 19.8879 11.2255 19.8518 11.2541L20.4668 12.6771L19.3896 11.555C19.3488 11.5764 19.3075 11.597 19.2657 11.6166L19.5323 13.1413L18.7459 11.8039C18.7012 11.8155 18.6562 11.826 18.6108 11.8356L18.5148 13.3798L18.0614 11.8992ZM17.9595 10.8111C19.01 10.8111 19.8615 9.97194 19.8615 8.93676C19.8615 7.90158 19.01 7.0624 17.9595 7.0624C16.9091 7.0624 16.0575 7.90158 16.0575 8.93676C16.0575 9.97194 16.9091 10.8111 17.9595 10.8111ZM19.0535 8.99162C19.0535 9.58363 18.5736 10.0635 17.9816 10.0635C17.3896 10.0635 16.9096 9.58363 16.9096 8.99162C16.9096 8.39962 17.3896 7.9197 17.9816 7.9197C18.5736 7.9197 19.0535 8.39962 19.0535 8.99162Z",
        fill: "#FFDC17"
      })]
    })]
  })]
}));
//# sourceMappingURL=Rwanda.js.map